import styled from 'styled-components';

export const PostsContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: #f5f7fa;
`;

export const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 280px;
  
  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

export const Header = styled.div`
  background: white;
  padding: 20px 32px;
  border-bottom: 1px solid #e8eaed;

  @media (max-width: 1024px) {
    padding: 16px 20px;
  }

  @media (max-width: 768px) {
    padding: 12px 16px;
  }
`;

export const HeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

export const HeaderTitle = styled.div``;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #202124;
  margin: 0 0 4px 0;

  @media (max-width: 1024px) {
    font-size: 22px;
  }

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: #5f6368;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const CalendarControls = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
    gap: 8px;
  }
`;

export const MonthNavigation = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    gap: 8px;
  }
`;

export const NavButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #1a73e8;
  background: white;
  color: #1a73e8;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #1a73e8;
    color: white;
  }

  .material-icons {
    font-size: 20px;
  }

  @media (max-width: 768px) {
    width: 36px;
    height: 36px;

    .material-icons {
      font-size: 18px;
    }
  }
`;

export const CurrentMonth = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #202124;
  min-width: 180px;
  text-align: center;

  @media (max-width: 1024px) {
    font-size: 15px;
    min-width: 150px;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    min-width: 120px;
  }
`;

export const TodayButton = styled.button`
  padding: 8px 16px;
  background: #1a73e8;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #1557b0;
  }

  @media (max-width: 1024px) {
    padding: 6px 12px;
    font-size: 13px;
  }

  @media (max-width: 768px) {
    padding: 6px 12px;
    font-size: 13px;
  }
`;

export const ViewButtons = styled.div`
  display: flex;
  gap: 8px;
  background: #f1f3f4;
  padding: 4px;
  border-radius: 8px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ViewButton = styled.button<{ $active?: boolean }>`
  padding: 8px 16px;
  background: ${props => props.$active ? 'white' : 'transparent'};
  color: ${props => props.$active ? '#1a73e8' : '#5f6368'};
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: ${props => props.$active ? '0 1px 2px rgba(0,0,0,0.1)' : 'none'};

  &:hover {
    color: #1a73e8;
  }

  @media (max-width: 1024px) {
    padding: 6px 12px;
    font-size: 13px;
  }

  @media (max-width: 768px) {
    flex: 1;
    padding: 6px 12px;
    font-size: 13px;
  }
`;

export const CalendarWrapper = styled.div`
  flex: 1;
  padding: 24px 32px;
  overflow-y: auto;

  @media (max-width: 1024px) {
    padding: 16px 20px;
  }

  @media (max-width: 768px) {
    padding: 12px;
  }
`;

export const Calendar = styled.div`
  background: white;
  border-radius: 12px;
  border: 1px solid #e8eaed;
  overflow: hidden;

  @media (max-width: 768px) {
    border-radius: 8px;
  }
`;

export const CalendarHeader = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  background: #f8f9fa;
  border-bottom: 1px solid #e8eaed;

  @media (max-width: 768px) {
    display: none; /* Esconde header em mobile */
  }
`;

export const WeekDay = styled.div`
  padding: 16px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: #5f6368;
  border-right: 1px solid #e8eaed;

  &:last-child {
    border-right: none;
  }

  @media (max-width: 1024px) {
    padding: 12px 8px;
    font-size: 12px;
  }
`;

export const CalendarGrid = styled.div<{ $viewType?: string }>`
  display: grid;
  grid-template-columns: ${props => {
    if (props.$viewType === 'day') return '1fr';
    if (props.$viewType === 'week') return 'repeat(7, 1fr)';
    return 'repeat(7, 1fr)';
  }};
  grid-auto-rows: ${props => props.$viewType === 'day' ? 'auto' : 'minmax(120px, 1fr)'};

  @media (max-width: 1024px) {
    grid-auto-rows: ${props => props.$viewType === 'day' ? 'auto' : 'minmax(100px, 1fr)'};
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr !important;
    grid-auto-rows: auto;
  }
`;

export const DayCell = styled.div<{ $isToday?: boolean; $isOtherMonth?: boolean; $viewType?: string }>`
  min-height: ${props => props.$viewType === 'day' ? '400px' : '120px'};
  padding: ${props => props.$viewType === 'day' ? '32px' : '8px'};
  border-right: 1px solid #e8eaed;
  border-bottom: 1px solid #e8eaed;
  background: ${props => props.$isOtherMonth ? '#f8f9fa' : 'white'};
  cursor: pointer;
  transition: background 0.2s ease;
  position: relative;

  &:nth-child(7n) {
    border-right: ${props => props.$viewType === 'day' ? '1px solid #e8eaed' : 'none'};
  }

  &:hover {
    background: #f8f9fa;
  }

  @media (max-width: 1024px) {
    min-height: ${props => props.$viewType === 'day' ? '350px' : '100px'};
    padding: ${props => props.$viewType === 'day' ? '24px' : '6px'};
  }

  @media (max-width: 768px) {
    min-height: auto;
    padding: 12px;
    border-right: 1px solid #e8eaed;
    display: flex;
    align-items: center;
    gap: 12px;

    &:nth-child(7n) {
      border-right: 1px solid #e8eaed;
    }
  }
`;

export const DayNumber = styled.div<{ $isToday?: boolean }>`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.$isToday ? 'white' : '#3c4043'};
  background: ${props => props.$isToday ? '#1a73e8' : 'transparent'};
  border-radius: 50%;
  margin-bottom: 4px;

  @media (max-width: 1024px) {
    width: 28px;
    height: 28px;
    font-size: 13px;
  }

  @media (max-width: 768px) {
    margin-bottom: 0;
    flex-shrink: 0;
  }
`;

export const PostIndicators = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 4px;

  @media (max-width: 1024px) {
    gap: 3px;
    margin-top: 3px;
  }

  @media (max-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 0;
    flex: 1;
  }
`;

export const PostBadge = styled.div<{ $status?: string }>`
  padding: 4px 8px;
  background: ${props => {
    switch (props.$status) {
      case 'published': return '#e8f5e9';
      case 'scheduled': return '#e3f2fd';
      default: return '#fff3e0';
    }
  }};
  color: ${props => {
    switch (props.$status) {
      case 'published': return '#2e7d32';
      case 'scheduled': return '#1565c0';
      default: return '#ef6c00';
    }
  }};
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 1024px) {
    font-size: 10px;
    padding: 3px 6px;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 6px 10px;
  }
`;

// Modal de Postagem
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 0;
    align-items: flex-start;
  }
`;

export const ModalContainer = styled.div`
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 1200px;
  max-height: 90vh;
  display: flex;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);

  @media (max-width: 1024px) {
    max-width: 95%;
    max-height: 95vh;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    max-height: 100vh;
    border-radius: 0;
    flex-direction: column;
  }
`;

export const ModalLeft = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e8eaed;

  @media (max-width: 768px) {
    border-right: none;
    border-bottom: 1px solid #e8eaed;
  }
`;

export const ModalHeader = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid #e8eaed;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 1024px) {
    padding: 18px 20px;
  }

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const ModalTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #202124;
  margin: 0;

  @media (max-width: 1024px) {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease;

  &:hover {
    background: #f8f9fa;
  }

  .material-icons {
    font-size: 24px;
    color: #5f6368;
  }

  @media (max-width: 768px) {
    padding: 6px;

    .material-icons {
      font-size: 20px;
    }
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  padding: 0 24px;
  border-bottom: 1px solid #e8eaed;
  background: white;

  @media (max-width: 1024px) {
    padding: 0 20px;
  }

  @media (max-width: 768px) {
    padding: 0 16px;
    overflow-x: auto;
  }
`;

export const Tab = styled.button<{ $active?: boolean }>`
  padding: 16px 20px;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  color: ${props => props.$active ? '#1a73e8' : '#5f6368'};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: -1px;
  white-space: nowrap;

  @media (max-width: 1024px) {
    padding: 14px 16px;
    font-size: 13px;
  }

  @media (max-width: 768px) {
    padding: 12px 16px;
    font-size: 13px;
  }

  ${props => props.$active && `
    border-bottom-color: #1a73e8;
  `}

  &:hover {
    color: #1a73e8;
    background: #f8f9fa;
  }
`;

export const ModalBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 24px;

  @media (max-width: 1024px) {
    padding: 20px;
  }

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const FormSection = styled.div`
  margin-bottom: 24px;

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
`;

export const Label = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #3c4043;
  margin-bottom: 8px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 150px;
  padding: 12px;
  border: 1px solid #dadce0;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  color: #3c4043;
  resize: vertical;
  transition: border 0.2s ease;

  &:focus {
    outline: none;
    border-color: #1a73e8;
  }

  &::placeholder {
    color: #9aa0a6;
  }
`;

export const CharCounter = styled.div`
  text-align: right;
  font-size: 12px;
  color: #5f6368;
  margin-top: 4px;
`;

export const ImageUploadArea = styled.div`
  border: 2px dashed #dadce0;
  border-radius: 8px;
  padding: 32px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;

  &:hover {
    border-color: #1a73e8;
    background: #f8f9fa;
  }

  @media (max-width: 768px) {
    padding: 24px 16px;
  }
`;

export const ImagePreviewContainer = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 16px;

  @media (max-width: 768px) {
    gap: 8px;
  }
`;

export const ImagePreview = styled.div`
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e8eaed;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const RemoveImageButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(234, 67, 53, 0.9);
  border: none;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #ea4335;
  }

  .material-icons {
    font-size: 16px;
  }
`;

export const AIButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 16px;
  flex-wrap: wrap;
`;

export const AIButton = styled.button`
  padding: 10px 20px;
  background: #4285f4;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 4px rgba(66, 133, 244, 0.2);

  .material-icons {
    font-size: 18px;
  }

  &:hover {
    background: #1a73e8;
    box-shadow: 0 4px 8px rgba(66, 133, 244, 0.3);
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SecondaryButton = styled.button`
  padding: 10px 20px;
  background: white;
  color: #5f6368;
  border: 1px solid #dadce0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;

  .material-icons {
    font-size: 18px;
  }

  &:hover {
    background: #f8f9fa;
    border-color: #bdc1c6;
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #dadce0;
  border-radius: 8px;
  font-size: 14px;
  color: #3c4043;
  background: white;
  cursor: pointer;
  transition: border 0.2s ease;

  &:focus {
    outline: none;
    border-color: #1a73e8;
  }
`;

export const DateTimeGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #dadce0;
  border-radius: 8px;
  font-size: 14px;
  color: #3c4043;
  transition: border 0.2s ease;

  &:focus {
    outline: none;
    border-color: #1a73e8;
  }
`;

// Preview da Postagem
export const ModalRight = styled.div`
  width: 400px;
  background: #f8f9fa;
  display: flex;
  flex-direction: column;

  @media (max-width: 1024px) {
    width: 320px;
  }

  @media (max-width: 768px) {
    width: 100%;
    max-height: 400px;
  }
`;

export const PreviewHeader = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid #e8eaed;
  background: white;

  @media (max-width: 1024px) {
    padding: 16px 20px;
  }

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const PreviewTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #202124;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;

  .material-icons {
    font-size: 20px;
    color: #5f6368;
  }

  @media (max-width: 768px) {
    font-size: 15px;

    .material-icons {
      font-size: 18px;
    }
  }
`;

export const PreviewBody = styled.div`
  flex: 1;
  padding: 24px;
  overflow-y: auto;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const PostPreviewCard = styled.div`
  background: white;
  border-radius: 12px;
  border: 1px solid #e8eaed;
  overflow: hidden;
`;

export const PostPreviewHeader = styled.div`
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ProfileIcon = styled.div`
  width: 48px;
  height: 48px;
  background: #4285f4;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  font-weight: 600;
  flex-shrink: 0;
`;

export const ProfileInfo = styled.div`
  flex: 1;
`;

export const ProfileName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #202124;
  margin-bottom: 2px;
`;

export const PostDate = styled.div`
  font-size: 12px;
  color: #5f6368;
`;

export const PostPreviewContent = styled.div`
  padding: 0 16px 16px;
`;

export const PostText = styled.p`
  font-size: 14px;
  line-height: 1.6;
  color: #3c4043;
  margin: 0 0 12px 0;
  white-space: pre-wrap;
`;

export const PostImages = styled.div<{ $count?: number }>`
  display: grid;
  grid-template-columns: ${props => props.$count === 1 ? '1fr' : 'repeat(2, 1fr)'};
  gap: 4px;
  border-radius: 8px;
  overflow: hidden;

  img {
    width: 100%;
    height: ${props => props.$count === 1 ? '300px' : '180px'};
    object-fit: cover;
  }
`;

export const EmptyPreview = styled.div`
  padding: 60px 20px;
  text-align: center;
  color: #9aa0a6;

  .material-icons {
    font-size: 64px;
    margin-bottom: 16px;
  }

  p {
    font-size: 14px;
    margin: 0;
  }
`;

export const ModalFooter = styled.div`
  padding: 16px 24px;
  border-top: 1px solid #e8eaed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: 768px) {
    padding: 12px 16px;
  }
`;

export const FooterLeft = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 8px;
  }
`;

export const FooterRight = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 8px;
    width: 100%;
  }
`;

export const CancelButton = styled.button`
  padding: 10px 24px;
  background: white;
  color: #5f6368;
  border: 1px solid #dadce0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f8f9fa;
    border-color: #bdc1c6;
  }
`;

export const SaveButton = styled.button<{ variant?: 'primary' | 'secondary' }>`
  padding: 10px 24px;
  background: ${props => props.variant === 'secondary' ? 'white' : '#1a73e8'};
  color: ${props => props.variant === 'secondary' ? '#1a73e8' : 'white'};
  border: ${props => props.variant === 'secondary' ? '1px solid #1a73e8' : 'none'};
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${props => props.variant === 'secondary' ? '#e8f0fe' : '#1557b0'};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 13px;
    flex: 1;
  }
`;

export const UploadIcon = styled.span`
  font-size: 48px;
  color: #5f6368;
  margin-bottom: 16px;
`;

export const UploadText = styled.p`
  margin: 0 0 8px 0;
  color: #5f6368;
  font-size: 14px;
`;

export const UploadHint = styled.p`
  margin: 0;
  color: #80868b;
  font-size: 12px;
`;

export const AIImageButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: #4285f4;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 12px;
  transition: all 0.2s ease;

  &:hover {
    background: #1a73e8;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(66, 133, 244, 0.4);
  }

  .material-icons {
    font-size: 18px;
  }
`;

// Dropdown de Visualização
export const ViewDropdown = styled.div`
  position: relative;
`;

export const DropdownButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: white;
  border: 1px solid #dadce0;
  border-radius: 8px;
  color: #202124;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f8f9fa;
  }

  .material-icons {
    font-size: 18px;
  }
`;

export const DropdownMenu = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  background: white;
  border: 1px solid #dadce0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 180px;
  z-index: 1000;
  opacity: ${props => props.$isOpen ? 1 : 0};
  visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
  transform: ${props => props.$isOpen ? 'translateY(0)' : 'translateY(-10px)'};
  transition: all 0.2s ease;
`;

export const DropdownItem = styled.button<{ $active?: boolean }>`
  width: 100%;
  padding: 12px 16px;
  background: ${props => props.$active ? '#e8f0fe' : 'white'};
  color: ${props => props.$active ? '#1a73e8' : '#202124'};
  border: none;
  text-align: left;
  font-size: 14px;
  font-weight: ${props => props.$active ? 600 : 400};
  cursor: pointer;
  transition: background 0.2s ease;

  &:first-child {
    border-radius: 8px 8px 0 0;
  }

  &:last-child {
    border-radius: 0 0 8px 8px;
  }

  &:hover {
    background: ${props => props.$active ? '#e8f0fe' : '#f8f9fa'};
  }
`;

// Visualização em Lista
export const ListView = styled.div`
  padding: 24px 32px;

  @media (max-width: 1024px) {
    padding: 16px 20px;
  }

  @media (max-width: 768px) {
    padding: 12px;
  }
`;

export const ListHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: 768px) {
    margin-bottom: 16px;
  }
`;

export const ListTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #202124;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const AddButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: #1a73e8;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #1557b0;
  }

  .material-icons {
    font-size: 18px;
  }
`;

export const PostsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PostCard = styled.div`
  background: white;
  border: 1px solid #dadce0;
  border-radius: 12px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #1a73e8;
  }

  @media (max-width: 768px) {
    padding: 16px;
    border-radius: 8px;
  }
`;

export const PostCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 12px;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    margin-bottom: 10px;
  }
`;

export const PostCardInfo = styled.div`
  flex: 1;
`;

export const PostCardDate = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1a73e8;
  margin-bottom: 4px;
`;

export const PostCardTime = styled.div`
  font-size: 12px;
  color: #5f6368;
`;

export const PostCardStatus = styled.div<{ $status?: string }>`
  padding: 6px 12px;
  background: ${props => {
    switch (props.$status) {
      case 'published': return '#e8f5e9';
      case 'scheduled': return '#e3f2fd';
      default: return '#fff3e0';
    }
  }};
  color: ${props => {
    switch (props.$status) {
      case 'published': return '#2e7d32';
      case 'scheduled': return '#1565c0';
      default: return '#ef6c00';
    }
  }};
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
`;

export const PostCardContent = styled.div`
  color: #202124;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 12px;
`;

export const PostCardImages = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 6px;
  }
`;

export const PostCardImage = styled.img`
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #dadce0;

  @media (max-width: 768px) {
    width: 60px;
    height: 60px;
    border-radius: 6px;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 80px 20px;
  color: #5f6368;
`;

export const EmptyStateIcon = styled.span`
  font-size: 64px;
  color: #dadce0;
  margin-bottom: 16px;
  display: block;
`;

export const EmptyStateText = styled.p`
  font-size: 16px;
  margin: 0 0 24px 0;
`;

// Visualização de Horários (Dia e Semana)
export const TimeGridContainer = styled.div`
  background: white;
  border-radius: 12px;
  border: 1px solid #e8eaed;
  overflow: hidden;
`;

export const TimeGridScroll = styled.div`
  max-height: calc(100vh - 300px);
  overflow-y: auto;
  overflow-x: hidden;
`;

export const TimeGridHeader = styled.div`
  display: grid;
  grid-template-columns: 80px repeat(auto-fit, minmax(150px, 1fr));
  border-bottom: 2px solid #e8eaed;
  background: #f8f9fa;
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const TimeGridHeaderCell = styled.div`
  padding: 16px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: #202124;
  border-right: 1px solid #e8eaed;

  &:first-child {
    background: white;
    border-right: 2px solid #e8eaed;
  }

  &:last-child {
    border-right: none;
  }
`;

export const TimeGridBody = styled.div`
  display: contents;
`;

export const TimeGridRow = styled.div<{ $columns?: number }>`
  display: grid;
  grid-template-columns: 80px repeat(${props => props.$columns || 1}, 1fr);
  
  &:hover {
    background: #fafbfc;
  }
`;

export const TimeSlot = styled.div`
  padding: 12px 8px;
  text-align: center;
  font-size: 12px;
  color: #5f6368;
  border-right: 2px solid #e8eaed;
  border-bottom: 1px solid #e8eaed;
  background: white;
  font-weight: 500;
`;

export const DayColumn = styled.div`
  position: relative;
  border-right: 1px solid #e8eaed;
  border-bottom: 1px solid #e8eaed;
  min-height: 60px;
  background: white;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #f8f9fa;
  }

  &:last-child {
    border-right: none;
  }
`;

export const TimePost = styled.div<{ $status?: string }>`
  margin: 4px;
  padding: 8px;
  background: ${props => {
    switch (props.$status) {
      case 'published': return '#e8f5e9';
      case 'scheduled': return '#e3f2fd';
      default: return '#fff3e0';
    }
  }};
  border-left: 3px solid ${props => {
    switch (props.$status) {
      case 'published': return '#2e7d32';
      case 'scheduled': return '#1565c0';
      default: return '#ef6c00';
    }
  }};
  border-radius: 4px;
  font-size: 12px;
  color: #202124;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
  }
`;

export const TimePostTime = styled.div`
  font-weight: 600;
  margin-bottom: 2px;
  font-size: 11px;
`;

export const TimePostText = styled.div`
  font-size: 11px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
